import { render, staticRenderFns } from "./SecureView.vue?vue&type=template&id=6172d909&"
var script = {}
import style0 from "./SecureView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports